"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var inputStyle = {
  display: 'none'
};

var FileInput =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(FileInput, _PureComponent);

  function FileInput(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.locked = false;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = FileInput.prototype;

  _proto.bindElement = function bindElement(el) {
    this.input = el;
  };

  _proto.click = function click() {
    var _this2 = this;

    if (this.locked) return;
    this.locked = true;
    this.input.value = '';
    this.input.click();
    setTimeout(function () {
      _this2.locked = false;
    }, 1000);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        accept = _this$props.accept,
        onChange = _this$props.onChange,
        multiple = _this$props.multiple,
        webkitdirectory = _this$props.webkitdirectory;
    return _react.default.createElement("input", {
      ref: this.bindElement,
      accept: accept,
      multiple: multiple,
      onChange: onChange,
      style: inputStyle,
      webkitdirectory: webkitdirectory,
      type: "file"
    });
  };

  return FileInput;
}(_react.PureComponent);

FileInput.propTypes = {
  accept: _propTypes.default.string,
  multiple: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  webkitdirectory: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])
};
var _default = FileInput;
exports.default = _default;